import UrlGeneration from '../urlGeneration';
import EstateLister from '../paginator/estate.js';
import ComplexLister from '../paginator/complex.js';
import FilterPanel from './filterPanel.js';
import FilterPrice from './filterPrice.js';
import request from "oc-request";
import * as Cookies from '../../libs/js.cookie.min.js'

// логика, которая будет применена после нажатия кнопки
function applyFilter(event) {
    event.preventDefault();

    // анализируем форму фильтра и пишем в адресную строку примененые фильтры
    // цена
    const obFilterPrice = new FilterPrice();
    obFilterPrice.run();
    // обычные опции
    const obFilterPanel = new FilterPanel();
    obFilterPanel.run();
    // кастомные опции (по бренду) - теория, на практике не проверял
    // const obFilterPanelBrand = new FilterPanel();
    // obFilterPanelBrand.setFieldName('brand');
    // obFilterPanelBrand.run();

    //
    const obEstateLister = new EstateLister(); // аналогично и для фильтра для ЖК, только с ../paginator/complex.js
    obEstateLister.setReplaceMode(true);
    obEstateLister.init(true);
}

// логика, которая будет применена после нажатия кнопки
function applyFilterOnMainPage(event) {
    event.preventDefault();
    if (document.querySelector('.main-selection_has-active-dropdown')) return;

    if(event.target.closest('form')) {
        const form = event.target.closest('form');
        const groups = form.querySelectorAll('[data-group-id]');
        groups.forEach(group => {
            form.querySelector(`#${group.dataset.groupId}`).checked = !!group.querySelectorAll('input:checked').length;
        })
    }
    let sEstateTypeSlug = 'live';
    if(document.querySelector('.estate_type input:checked')) {
        sEstateTypeSlug = document.querySelector('.estate_type input:checked').value;
    }

    // анализируем форму фильтра и пишем в адресную строку примененые фильтры
    // цена
    const obFilterPrice = new FilterPrice();
    obFilterPrice.run();

    // обычные опции
    const obFilterPanel = new FilterPanel();
    obFilterPanel.run();

    Cookies.set('fromMainPageFilter', true);

    window.location = '/catalog/' + sEstateTypeSlug + '/query' + window.location.search;
}
function applyFilterOnComplex(event) {
    event.preventDefault();

    // // обычные опции
    const obFilterPanel = new FilterPanel();
    obFilterPanel.run();

    const obComplexLister = new ComplexLister(); // аналогично и для фильтра для ЖК, только с ../paginator/complex.js
    obComplexLister.setReplaceMode(true);
    obComplexLister.init(true);
}
function changeEstateTypeFilter() {
    document.body.classList.add('_filter-preload');
    const estateClassId = this.querySelector('input[type=radio]:checked').value;
    request.sendData('EstateTypeData::onAjaxRequest', {
        data: {
            estate_type_id: estateClassId
        },
        update: { 'page-main/estate_type_filter': '#estate_type_filter' },
        success: () => {
            window.selectInit();
            document.body.classList.remove('_filter-preload');
        },
    });
}
function changeMainPageCountryFilter() {
    document.body.classList.add('_filter-preload');
    const countries = this.querySelectorAll('input[type=checkbox]:checked');
    let data = []
    countries.forEach(function (item) {
        data.push(item.value)
    });
    request.sendData('GeoObjectList::onAjaxRequest', {
        data: {
            country_ids: data
        },
        update: { 'page-main/city_filter': '#city_filter' },
        success: () => {
            window.selectInit();
            document.body.classList.remove('_filter-preload');
        },
    });
}

function changeCountryFilter() {
    document.body.classList.add('_filter-preload');
    const countries = this.querySelectorAll('input[type=radio]:checked');
    let data = []
    countries.forEach(function (item) {
        data.push(item.value)
    });
    request.sendData('GeoObjectList::onAjaxRequest', {
        data: {
            ids: data
        },
        update: { 'filter/filter-location-dropdowns': '#city_filer' },
        success: () => {
            window.selectInit();
            document.body.classList.remove('_filter-preload');
            changeCityFilter.call(document.querySelector(`#city_filer`));
        },
    });
}
function changeCityFilter() {
    document.body.classList.add('_filter-preload');

    const cities = this.querySelectorAll('input[type=checkbox]:checked');
    let data = []
    cities.forEach(function (item) {
        data.push(item.value)
    });
    request.sendData('GeoObjectList::onAjaxRequest', {
        data: {
            ids: data
        },
        update: {
            'filter/filter-district-dropdowns': '#district_filer',
        },
        success: () => {
            window.selectInit();
            document.body.classList.remove('_filter-preload');
            changeDistrictFilter.call(document.querySelector(`#district_filer`));
        },
    });
}
function changeDistrictFilter() {
    document.body.classList.add('_filter-preload');

    const cities = this.querySelectorAll('input[type=checkbox]:checked');
    let data = []
    cities.forEach(function (item) {
        data.push(item.value)
    });
    request.sendData('GeoObjectList::onAjaxRequest', {
        data: {
            ids: data
        },
        update: {
            'filter/filter-metro-dropdowns': '#metro_filter',
        },
        success: () => {
            window.selectInit();
            document.body.classList.remove('_filter-preload');
        },
    });
}

function moveToOtherEstateTypeCatalogFilter(e) {
    e.preventDefault();

    // анализируем форму фильтра и пишем в адресную строку примененые фильтры
    // цена
    const obFilterPrice = new FilterPrice();
    obFilterPrice.run();

    // обычные опции
    const obFilterPanel = new FilterPanel();
    obFilterPanel.run();


    let estateType = e.target.getAttribute('data-estate-type');
    // TODO:квери запрос появляется только после применения фильтра.
    window.location = '/catalog/' + estateType + '/' + window.location.search;
};

function changeAnnouncementTypeFilter() {
    const announcementTypeValue = this.querySelector(`input[type=radio]:checked`).value;
    // 2 == rent
    if (announcementTypeValue !== undefined && announcementTypeValue == 2) {
        document.querySelector('[data-property-slug="renovation"]').hidden = true
        document.querySelectorAll('[data-property-slug="renovation"] input:checked').forEach(function (item) {
            item.checked = false;
        })
    } else {
        document.querySelector('[data-property-slug="renovation"]').hidden = false
    }
}

// TODO: Проверить чтобы price|asc работала также с разными валютами
// TODO: Нажатие на ентер производить переход где-то ещё. но уже очищая query запрос.
function init() {
    // ищем кнопку, при нажатии на которую применяем фильтр
    const applyBtn = document.querySelector(`[data-filtrator-btn]`);
    const searchBar = document.querySelector('.catalog-list__filter-input-wrap > input');
    const searchIcon = document.querySelector('.catalog-list__filter-input-wrap > img');

    if (applyBtn) {
        applyBtn.addEventListener('click', applyFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
    }

    if (searchBar) {
        searchBar.addEventListener('keydown', function (e) {
            // клавиша 13 это Enter, также кнопка Go на мобильной версии
            if (e.keyCode === 13) {
                e.preventDefault();
                applyFilter(e);
            }
        });
    };

    // При клике на иконку поисковика происходит эевт как при клике на кнопку.
    if (searchIcon) {
        searchIcon.addEventListener('click', applyFilter, false);
    }


    // ищем кнопку на главной странице, при нажатии на которую применяем фильтр
    const applyBtnMain = document.querySelector(`[data-filtrator-btn-main] `);
    if (applyBtnMain) {
        applyBtnMain.addEventListener('click', applyFilterOnMainPage, false);
    }

    // ищем кнопку на странице комплексов, при нажатии на которую применяем фильтр
    const complexFilters = document.querySelectorAll(`[data-filtrator-complex] .select__item`);
    if (complexFilters) {
        complexFilters.forEach(function(item){
            item.addEventListener('click', applyFilterOnComplex, false);
        })
    }

    const estateClassChanger = document.querySelector(`[data-estate_class-changer-btn]`);
    if (estateClassChanger) {
        estateClassChanger.addEventListener('change', changeEstateTypeFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
    }

    const countryChanger = document.querySelector(`[data-country-changer-btn]`);
    if (countryChanger) {
        countryChanger.addEventListener('change', changeCountryFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
    }

    /*
    const mainPageCountryChanger = document.querySelector(`[data-main-page-country-changer-btn]`);
    if (mainPageCountryChanger) {
        mainPageCountryChanger.addEventListener('change', changeMainPageCountryFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
    }
    */

    const cityChanger = document.querySelector(`#city_filer`);
    if (cityChanger) {
        cityChanger.addEventListener('change', changeCityFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
        cityChanger.addEventListener('click', (e) => {
            if (e.target.closest('.select__checkbox-reset')) {
                changeCityFilter.call(cityChanger);
            }
        })
    }

    function addGlobalListener(el, type, callbackFn, selector) {
        el.addEventListener(type, e => {
            const target = e.target.closest(selector);
            if (target) callbackFn.call(target, e);
        }, true);
    }

    let cityCheckboxSelector = '#city_filer .simple-checkbox.filter-dropdown__checkbox > input';
    let cityCheckboxesSelector = ".filter-dropdown__checkbox-group";
    addGlobalListener(document, 'change', function(event) {
        let input = event.target;

        if (input.checked === true) {
            let inputContainer = input.closest(cityCheckboxesSelector);
            let otherInputs = inputContainer.querySelectorAll(cityCheckboxSelector);

            otherInputs.forEach( (otherInput) => {
                otherInput.checked = false;
            });

            input.checked = true;
        }
    }, cityCheckboxSelector);

    /*
    cityCheckboxes.forEach( (el) => {
        el.addEventListener('change', (event) => {

        });
    });*/

    const districtChanger = document.querySelector(`#district_filer`);
    if (districtChanger) {
        districtChanger.addEventListener('change', changeDistrictFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
        districtChanger.addEventListener('click', (e) => {
            if (e.target.closest('.select__checkbox-reset')) {
                changeDistrictFilter.call(districtChanger);
            }
        })
    }

    const typeChangers = document.querySelectorAll(`.filter__item-estate-type, .filter__item-estate-subtype`);
    if (typeChangers) {
        typeChangers.forEach(el => {
            el.querySelectorAll('.filter__link').forEach( el2 => {
                el2.addEventListener('click', moveToOtherEstateTypeCatalogFilter);
            });
        })
    }

    const selector = document.querySelector(`.filter [data-filter-property-id="announcement_type"]`);
    if (selector) {
        selector.addEventListener('change', changeAnnouncementTypeFilter, false); // для ЖК тут будет 'change' и следить надо будет за инпутами, а не одной кнопкой
    }
}

init();
